import { render } from "./AddPropositionReponsePage.vue?vue&type=template&id=61082122&ts=true"
import script from "./AddPropositionReponsePage.vue?vue&type=script&lang=ts"
export * from "./AddPropositionReponsePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__